import { color_black, color_grey_dark, color_grey_light, color_grey_ultra_light, color_white } from "../../constants/colors";
import { useWindowDimensions } from "../../utils";
import { OnestNormalDefault, OnestNormalSmall } from "../styled/TextComponents";
import { BlockTitle } from "../text/BlockTitle";
import { useSelector } from "react-redux";
import { useI18n } from "../../i18n/I18nProvider";

const WIDE_DESKTOP_WIDTH = 1700;

export const StudentScheduleBlock = ({ text }) => (
    <div style={{
        flex: 1,
        minHeight: 40,
        borderRadius: 10,
        backgroundColor: color_grey_ultra_light,
        color: color_black,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
    }}>
        <OnestNormalDefault>{text}</OnestNormalDefault>
    </div>
);

const ScheduleRows = ({ lessonsSchedule }) => {
    const { t } = useI18n();
    return (
    <>
        {lessonsSchedule.map((el, index) => (
            <div
                key={`${el.weekDayShort}-${el.time}-${index}`}
                style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 10,
                }}
            >
                <StudentScheduleBlock text={t(el.weekDay)} />
                <StudentScheduleBlock text={`${el.time.split(" - ")[0]} - ${el.time.split(" - ")[1]}`} />
            </div>
        ))}
    </>
    );
};

export const StudentSchedule = () => {
    const { t } = useI18n();
    const { width: screenWidth } = useWindowDimensions();
    const isDesktop = screenWidth > 1155;
    const student = useSelector((state) => state.student);
    const periodsDisplay = student.learningPeriodsDisplay || [];
    const hasPeriodsDisplay = periodsDisplay.length > 0;
    const hasLegacySchedule = student.lessonsSchedule.length > 0;

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            width: screenWidth >= WIDE_DESKTOP_WIDTH ? "100%" : (isDesktop ? 600 : "100%"),
            borderRadius: 20,
            padding: 25,
            backgroundColor: color_white,
            boxSizing: "border-box",
            gap: 20,
        }}>
            <BlockTitle title={t("Расписание занятий")} />

            {hasPeriodsDisplay ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                    {periodsDisplay.map((period) => (
                        <div
                            key={period.id}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 10,
                                padding: period.isActive ? "12px" : "0",
                                borderRadius: 12,
                                border: period.isActive ? `1px solid ${color_grey_light}` : "none",
                                backgroundColor: "transparent",
                            }}
                        >
                            <OnestNormalSmall style={{ color: color_grey_dark }}>
                                {t("Период")}: {period.label}
                                {` (${t(period.statusLabel)})`}
                            </OnestNormalSmall>
                            {period.lessonsSchedule.length > 0 ? (
                                <ScheduleRows lessonsSchedule={period.lessonsSchedule} />
                            ) : (
                                <div style={{
                                    minHeight: 56,
                                    borderRadius: 10,
                                    backgroundColor: color_grey_ultra_light,
                                    color: color_grey_dark,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "8px 10px",
                                }}>
                                    <OnestNormalDefault>{t("Дни и время не заданы")}</OnestNormalDefault>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            ) : hasLegacySchedule ? (
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    {student.learningPeriodLabel && (
                        <OnestNormalSmall style={{ color: color_grey_dark }}>
                            {t("Период")}: {student.learningPeriodLabel}
                        </OnestNormalSmall>
                    )}
                    <ScheduleRows lessonsSchedule={student.lessonsSchedule} />
                </div>
            ) : (
                <div style={{
                    height: 90,
                    borderRadius: 10,
                    backgroundColor: color_grey_ultra_light,
                    color: color_grey_dark,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingLeft: 10,
                    paddingRight: 10,
                }}>
                    <OnestNormalDefault>{t("Здесь будет расписание занятий ученика")}</OnestNormalDefault>
                </div>
            )}
        </div>
    );
};
